import React from 'react';
import { PlaceOfDeliveryConsumptionFullDTO } from 'features/placeOfDelivery/dtos/PlaceOfDeliveryConsumptionFullDTO';
import PlaceOfDeliveryMonthConsumption from './PlaceOfDeliveryMonthConsumption';
import DataGridRow from 'features/shared/components/dataGrid/DataGridRow';
import PlaceOfDeliveryMonthConsumptionHeader from './PlaceOfDeliveryMonthConsumptionHeader';

type Props = {
  placeOfDeliveryConsumption: PlaceOfDeliveryConsumptionFullDTO;
  isProduction?: boolean;
}

const PlaceOfDeliveryMonthConsumptionGrid = ({ placeOfDeliveryConsumption, isProduction }: Props) => {
  // sub-renders
  const renderConsumptions = () => { 
    let result: JSX.Element[] = [];
    let planConsumptions = placeOfDeliveryConsumption.planConsumption?.measuredValues ?? [];
    let realConsumptions = placeOfDeliveryConsumption.realConsumption?.measuredValues ?? [];

    for (let i = 0; i < planConsumptions.length; i++) {
      const planConsumption = planConsumptions[i];
      
      let realConsumption = realConsumptions.find(
        (x) => x.from === planConsumption.from && x.to === planConsumption.to
      );

      if (realConsumption) {
        let elem = (
          <DataGridRow key={i}>
            <PlaceOfDeliveryMonthConsumption
              planConsumption={planConsumption}
              realConsumption={realConsumption}
              isProduction={isProduction}
            />
          </DataGridRow>
        );
      
        result.push(elem);
      }
    }

    return result;
  }

  // render
  return (
    <>
      <PlaceOfDeliveryMonthConsumptionHeader isProduction={isProduction} />
      {renderConsumptions()}
    </>
  )
}

export default PlaceOfDeliveryMonthConsumptionGrid;